import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { Trans } from '@/components/tools/translation';

export const avgEngagementReachConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.tiktok.avg_engagement_reach_post',
    id: 'average_engagement_on_reach_per_video',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    tooltip: (
        <Trans
            i18nKey="analytics:kpi.tiktok.tooltip_avg_engagement_reach_post"
        />
    ),
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: DefaultLoader,
    noDataToken: 'analytics:kpi.tiktok.no_posts_period',
    element: KPIDefault,
    new: {
        dateAdded: '2026-02-02'
    }
};
